import { useEffect, useState } from 'react';

// Browser-local mock for auctions to avoid bundling backend code
type Auction = { id:string; tokenId:string; reservePrice:number; end:string; bids:Array<{ companyId:string; amount:number; ts:string }> };
const LS_KEY = 'evat:auctions';
function read(): { auctions: Auction[] }{ try{ const r = localStorage.getItem(LS_KEY); return r? JSON.parse(r): { auctions: [] }; }catch{ return { auctions: [] }; } }
function write(db: { auctions: Auction[] }){ try{ localStorage.setItem(LS_KEY, JSON.stringify(db)); }catch{} }
function listAuctions(): Auction[]{ return read().auctions.slice(-50).reverse(); }
function createAuction(tokenId: string, reservePrice: number, end: string): Auction { const db = read(); const a: Auction = { id:`auc-${Date.now()}`, tokenId, reservePrice, end, bids:[] }; db.auctions.push(a); write(db); return a; }
function placeBid(id: string, companyId: string, amount: number){ const db = read(); const a = db.auctions.find(x=>x.id===id); if(!a) return; a.bids.push({ companyId, amount, ts:new Date().toISOString() }); write(db); }

export function AuctionHouse() {
  const [tokenId, setTokenId] = useState('1');
  const [reserve, setReserve] = useState(100);
  const [end, setEnd] = useState(new Date(Date.now()+86400000).toISOString().slice(0,16));
  const [rows, setRows] = useState(listAuctions());
  const [amount, setAmount] = useState(110);
  const reload = () => setRows(listAuctions());
  const create = () => { createAuction(tokenId, reserve, end); reload(); };
  const bid = (id: string) => { placeBid(id, 'demoCo', amount); reload(); };
  useEffect(()=>{ reload(); },[]);
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">Secondary Certificate Auction</div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 text-sm">
        <input value={tokenId} onChange={(e)=>setTokenId(e.target.value)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1" placeholder="tokenId"/>
        <input type="number" value={reserve} onChange={(e)=>setReserve(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1" placeholder="reserve"/>
        <input type="datetime-local" value={end} onChange={(e)=>setEnd(e.target.value)} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1"/>
        <button onClick={create} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">List Auction</button>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <input type="number" value={amount} onChange={(e)=>setAmount(Number(e.target.value))} className="bg-black border border-evat-gold text-evat-gold rounded px-2 py-1" placeholder="bid amount"/>
        <div className="text-xs text-neutral-500">Countdown/settlement demo only</div>
      </div>
      <div className="border border-neutral-700 rounded p-2 text-xs max-h-64 overflow-auto">
        {rows.map(a => (
          <div key={a.id} className="mb-1">
            <div className="flex justify-between"><span>{a.id} • token {a.tokenId} • reserve €{a.reservePrice}</span><button onClick={()=>bid(a.id)} className="px-2 py-1 rounded border border-evat-gold text-evat-gold">Bid</button></div>
            <div className="text-neutral-400">Bids: {a.bids.map(b=> `${b.companyId} €${b.amount}`).join(', ') || '-'}</div>
          </div>
        ))}
        {rows.length===0 && <div className="text-neutral-500">No auctions</div>}
      </div>
    </div>
  );
}

export default AuctionHouse;



